import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const createTemplateValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    id: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    name: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    nameEn: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    subject: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_L, i18n.t("validation.charCount.invalid.1000")),
    isHtml: yup.boolean().required(),
    text: yup.string().required(),
  });
};
